var countryCode = '';

(function($) {

    var frameworkNS = {

        // All pages
        common: {
            init: function () {


                /*-----------------------------------------------------------------------------------*/
                /*  Update Currency dropdown
                /*-----------------------------------------------------------------------------------*/

                var _ddlLoaded = false;
                jQuery('#currency-dropdown').ddslick({
                    onSelected: function(data)
                    {
                        if (_ddlLoaded === false) {
                            _ddlLoaded = true;
                            jQuery('#currency-dropdown').show();
                        } else {
                            var countryUrl = data.selectedData.value;
                            location.href = countryUrl;
                        }
                    }
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Move mobile currency switcher
                /*-----------------------------------------------------------------------------------*/

                $(window).on('resize', function() {
                    responsive_viewport = $(window).width();

                    if (responsive_viewport >= 768) {

                        if ($(".nav-button-bars").hasClass("active")) {
                            $(".nav-button-bars").removeClass('active');
                        }
                        if ($("body").hasClass("menu-open")) {
                            $("body").removeClass('menu-open');
                        }

                        // Move the mobile currency switcher to the desktop masthead
                        if ($('#mobile-menu-currency-switcher #currency-dropdown').length > 0){

                            $('#mobile-menu-currency-switcher').contents().appendTo("#masthead-currency-switcher");
                            $('#mobile-menu-currency-switcher #currency-dropdown').remove();
                        }
                    } else {
                        // Move the desktop currency switcher to the mobile menu
                        if ($('#masthead-currency-switcher #currency-dropdown').length > 0){

                            $('#masthead-currency-switcher').contents().appendTo("#mobile-menu-currency-switcher");
                            $('#masthead-currency-switcher #currency-dropdown').remove();
                        }
                    }
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Mobile menu
                /*-----------------------------------------------------------------------------------*/

                $('#mobile-menu-button').click(function () {
                    $('.nav-button-bars').toggleClass('active');
                    $('body').toggleClass('menu-open');
                });

                $('#menu-main-menu li.menu-item-has-children').each(function (i, el) {
                    var $subMenuWrap = $(el).children('.sub-menu-wrap'),
                        $subMenu = $subMenuWrap.children('.sub-menu'),
                        $expandIcon = $('<span />').addClass('expand').appendTo($(el));


                    $expandIcon.on('click', function () {
                        if ($(el).hasClass('menu-item-expanded')) {
                            $subMenuWrap.animate({'height': 0}, 200, function () {
                            });
                            $(el).removeClass('menu-item-expanded');
                        } else {
                            var menuHeight = $subMenu.outerHeight();
                            $subMenuWrap.animate({'height': menuHeight}, 200, function () {
                            });
                            $(el).addClass('menu-item-expanded');
                        }
                    });
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Scroll To Top
                /*-----------------------------------------------------------------------------------*/

                $("#scroll-to-top, #navbutton-wrapper").click(function (){

                    $('html, body').animate({
                        scrollTop:0
                    });

                });

                /*-----------------------------------------------------------------------------------*/
                /*  Headroom
                /*-----------------------------------------------------------------------------------*/

                var mainElement = document.querySelector("#mobile-nav-wrapper");
                // Initialise with callback to close dropdown on unpin
                if (mainElement) {
                    var headroom = new Headroom(mainElement, {
                        tolerance: {
                            down: 10,
                            up: 20
                        }
                    });

                    // initialise
                    headroom.init();
                }

                /*-----------------------------------------------------------------------------------*/
                /*  Moving Header
                /*-----------------------------------------------------------------------------------*/

                $(window).scroll(function (event) {
                    // what the y position of the scroll is
                    var y = $(this).scrollTop();

                    var windowHeight = $(window).height();
                    //console.log('windowHeight = '+windowHeight);
                    var mastheadHeight = $('#masthead-nav').outerHeight(true);
                    //console.log('mastheadHeight = '+mastheadHeight);

                    // We only need the moving header if the height of the document is much greater
                    // than the viewport.  We add in 200 as a buffer.
                    var combined = Number(windowHeight) + Number(mastheadHeight) + 200;
                    //console.log('combined = '+combined);

                    //console.log('y = '+y);
					//console.log('document.body.scrollHeight = '+document.body.scrollHeight);
                    if ( y >= ($('#masthead-nav').outerHeight(true)) && document.body.scrollHeight > combined ) {
                        $('#masthead-nav').addClass('moving-header');
                    } else {
                        $('#masthead-nav').removeClass('moving-header');
                    }

                });

                /*-----------------------------------------------------------------------------------*/
                /*  Show/Hide 'Order Now' button on mobile when scrolling
                /*-----------------------------------------------------------------------------------*/

                $(document).scroll(function() {

                    var y = $(this).scrollTop();

                    if (y > 600) {
                        $('#mob-footer-buy-wrapper').addClass('show-mobile show-tablet');
                    } else {
                        $('#mob-footer-buy-wrapper').removeClass('show-mobile show-tablet');
                    }

                });

                /*-----------------------------------------------------------------------------------*/
                /*  Initialize the FAQ accordion
                /*-----------------------------------------------------------------------------------*/

                $(".faq-item").click(function() {
                    $(this).toggleClass('active');
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Research Reveal Button
                /*-----------------------------------------------------------------------------------*/

                $("#research-button").click(function() {
                    $(this).next().toggleClass('active');
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Popup Supplement Facts Image
                /*-----------------------------------------------------------------------------------*/

                $(".supplement-fact").click(function() {

                    var supplementImageUrl = $(this).data("facts");

                    var supplementImage = new jPopup({

                        content: '<div class="supplement-facts-popup"><img src="'+ supplementImageUrl +'" alt="Supplement Facts" /></div>'

                    });

                });

                /*-----------------------------------------------------------------------------------*/
                /*  Update cart when qty input clicked
                /*-----------------------------------------------------------------------------------*/

                $('.cart-counter').on('click', function() {
                    if ($('body').hasClass("js-drawer-open")) {
                        $(".js-drawer-close").trigger("click");
                    } else {
                        ajaxCart.load();
                        timber.RightDrawer.open();
                    }
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Smooth Scroll
                /*-----------------------------------------------------------------------------------*/

                $(".smooth-scroll").click(function (){
                    var section = $(this).attr('href');
                    $('html, body').animate({
                        scrollTop: $(section).offset().top - 150
                    });
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Get Blog Post Word Count - if on a page where .rte and .readingtime exist
                /*-----------------------------------------------------------------------------------*/

                function readingTime(wordCount) {
                    const wordsPerMinute = 200;
                    const minutes = wordCount / wordsPerMinute;
                    const readTime = Math.ceil(minutes);
                    return readTime + ' minute read';
                }

                function get_text(el) {
                    ret = "";
                    var length = el.childNodes.length;
                    for(var i = 0; i < length; i++) {
                        var node = el.childNodes[i];
                        if(node.nodeType != 8) {
                            ret += node.nodeType != 1 ? node.nodeValue : get_text(node);
                        }
                    }
                    return ret;
                }

                var blogContent = document.getElementById("blog-content");
                var blogTime = document.getElementById("readingtime");

                if (blogContent){
                    var words = get_text(blogContent);
                    var wordCount = words.split(/\s+/).length;
                    var readingHtml = readingTime(wordCount);
                    blogTime.innerHTML = readingHtml;
                }

                /*-----------------------------------------------------------------------------------*/
                /*  Cookies - Setter and Getter
                /*-----------------------------------------------------------------------------------*/

                function setCookie(name, value) {
                    const expiryDate = new Date();
                    expiryDate.setTime(expiryDate.getTime() + (30 * 24 * 60 * 60 * 1000)); // Cookie will expire in 30 days
                    const expires = "expires=" + expiryDate.toUTCString();
                
                    // Set domain to your main domain with a dot prefix
                    const domain = ";domain=.burnlabpro.com";

                    document.cookie = name + "=" + value + ";" + expires + domain + ";path=/";
                }

                function getCookie(name) {
                    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                    return v ? v[2] : null;
                }

                /*-----------------------------------------------------------------------------------*/
                /*  Submit localization form
                /*-----------------------------------------------------------------------------------*/

                function submitLocalizationForm (optionCode) {

                    const formCodes = ['GB','BE','CA','AU','US'];

                    if (!formCodes.includes(optionCode)) {
                        // The form doesn't include an option with the value of the country code
                        // We need to add one or the form submission won't work.
                        $('#localization_form [name=country_code]').prepend($('<option>', {
                            value: optionCode,
                            text: ''
                        }));
                        
                    }

                    $('#localization_form [name=country_code]').val(optionCode);
                    // Submit the form
                    $('#localization_form').submit();

                }

                /*-----------------------------------------------------------------------------------*/
                /*  Localization Handler
                /*-----------------------------------------------------------------------------------*/

                function localizationHandler (countryCode) {

                    const gbCodes = ['GB','IM','GG','JE','GI'];
                    const euCodes = ['AT','BE','CY','EE','FI','FR','DE','GR','IE','IT','LV','LT','LU','MT','NL','PT','SK','SI','ES','AD','MC','SM','VA','BG','HR','CZ','DK','HU','PL','RO','SE','NO','CH','EE'];
                    const marketHandle = document.body.getAttribute('data-market');

                    if (
                        marketHandle == countryCode.toLowerCase() || // for US, CA, and AU
                        (marketHandle == 'eu' && euCodes.includes(countryCode)) || // € country
                        (marketHandle == 'gb' && gbCodes.includes(countryCode)) // £ country/dependancy
                    ) {
                        // We are in the correct store. Exit.
                        return;
                    } else {
                        // We need to submit the form
                        submitLocalizationForm(countryCode);
                    }  
                }

                /*-----------------------------------------------------------------------------------*/
                /*  Retrieve user GeoIP from API call
                /*-----------------------------------------------------------------------------------*/

                function getCountryCode () {

                    return fetch('https://api.ipgeolocation.io/ipgeo')
    
                    .then(response => response.json())
                    .then(data => {
                        let countryCode = data.country_code2;
                        return countryCode;
                    })
                    .catch(error => {
                        console.error('Error fetching IP information:', error);
                        return null;
                    });

                }

                /*-----------------------------------------------------------------------------------*/
                /*  Manual Currency Switching using select dropdown
                /*-----------------------------------------------------------------------------------*/
               
                $('#localization_form [name=country_code]').on('change', function() {
                    
                    const cookieValue = $(this).val();
                    const cookieName = 'blp_country';
                    // We set a cookie blp-country cookie
                    setCookie(cookieName,cookieValue);

                    submitLocalizationForm(cookieValue);
                });

                /*-----------------------------------------------------------------------------------*/
                /*  Automated Currency Switching - Check cookies, currency set and switch if necessary.
                /*-----------------------------------------------------------------------------------*/

                function currencySwitchCheck () {

                    const currentHostname = new URL(window.location.href).hostname;
                    const countryCookie = getCookie('blp_country');
                    const cookieName = 'blp_country';

                    // Extra check to see if the 4 box gets free shipping in user locale.
                    // Show US specific content
                    if (countryCookie == 'US' || countryCookie == 'GB') {
                        $('.show-free-shipping').show();
                        if (countryCookie == 'US') {
                            $('.show-us-only').show();
                        } else {
                            $('.show-restofworld').show();
                        }
                    }

                    // Check if it's a dev site and bail out if so
                    if (currentHostname.includes('myshopify.com')) {
                        return;
                    }

                    // Is cookie set? If so we check the market value and either switch or stay
                    if (countryCookie) {  
                        localizationHandler (countryCookie);
                        return;
                    }

                    // There's no cookie we need to get the user country code
                    getCountryCode().then(countryCode => {

                        // Check that countryCode is not null before setting cookie
                        if (countryCode) {
                            setCookie(cookieName, countryCode);
                            localizationHandler(countryCode);
                        } else {
                            console.log('Country code not available');
                        }
                        return;

                    }).catch(error => {
                        console.error('Error:', error);
                    });
                    
                }

                currencySwitchCheck();

                UTIL.flickity();
            }
        },

        // Home page
        home: {
            init: function () {

                // JS here

            }
        },

        template_page: {
            init: function() {
                //general.references();
            }
        },

         // Blog page
        template_article: {
            init: function () {
                
                // Adds Collapsed (so hidden with css) Class and +/- Sign.ClickTrigger
                // Idea being if JS doesn't load the references are still shown/expanded
                $(".references-section").addClass('collapsed');

                $(".references-section h4").append('<span class="plus-minus"></span>');

                // Toggle opening and closing of reference section. Animation handled by css.
                $('.references-section h4').click(function(event){
                    event.preventDefault();
                    $(event.target).closest('.references-section').toggleClass('collapsed');
                });

                // Reposition the sidebar CTA to allow position sticky to work.
                $cta = $('.article-sidebar-cta');
                $('#blog-content').prepend($cta);

                // Click event to open new window with adjustable dimensions for Social sharing
                $('.blog-sidebar-social-share-link-window').on('click', function(event) {
                    // Check for existence of data attributes to allow window override.
                    var windowHeight = ( $(event.target).data('height') ?  $(event.target).data('height') : 450 );
                    var windowWidth = ( $(event.target).data('width') ?  $(event.target).data('width') : 800 );
                    window.open(
                        this.href,
                        'targetWindow',
                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width='+windowWidth+',height='+windowHeight);
                    return false;
                });
            }
        }
    };

    // You can ignore this part, this is used to check and fire the above based on the body class
    var UTIL = {
        fire: function (func, funcname, args) {
            var namespace = frameworkNS;
            funcname = (funcname === undefined) ? 'init' : funcname;
            if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {

            UTIL.fire('common');

            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
            });

            UTIL.fire('common', 'finalise');
        },
        // Little function to show/hide the research section to get its acttual height.
        // Allows for smoother animation with all CSS fallback.
        resizeResearch: function() {
            $researchSection = $('.research-section');
            $researchSection.css('max-height','none');
            researchHeight = $researchSection.height();
            $researchSection.css('max-height','0');
            $('head').append('<style id="researchCSS" type="text/css">.research-section.active {max-height:' + researchHeight + 'px!important;}</style>');
        },
        flickity: function() {

            var slideLength = 2;

            var $carousel = $('.carousel-main').flickity({
                lazyLoad: true,
                pageDots: true,
                prevNextButtons: false,
                wrapAround: true,
                pauseAutoPlayOnHover: true,
                on: {
                    ready: function() {
                        // Move the icons inside the carousel main to allow absolute
                        // absolute bottom to work properly.
                        $('.carousel-icons').prependTo('.carousel-main');
                    }
                }
            });

            $('.carousel-nav').flickity({
                asNavFor: '.carousel-main',
                contain: true,
                pageDots: false,
                prevNextButtons: false
            });

            $carouselIcons = $('#carousel-product-features').flickity({
                contain: true,
                pageDots: false,
                groupCells: true,
                on: {
                  ready: function() {
                    slideLength = this.slides.length;
                    showHidePrevNext();
                  },
                  resize: function() {
                    slideLength = this.slides.length;
                    showHidePrevNext();
                  },
                },
            });

            $carousel.on( 'change.flickity', function( event, index ) {
                var $carouselIcons = $('.carousel-icons');
                if (index > 0) {
                    $carouselIcons.addClass('hidden');
                } else {
                    $carouselIcons.removeClass('hidden');
                }
            });

            // If more than one set of slides/scenes then show buttons,
            // otherwise just be a static slide (MCT)
            function showHidePrevNext() {
                $featuredIconsButtons = $('#carousel-product-features .flickity-button');
                if(slideLength > 1) {
                    $featuredIconsButtons.removeClass('hide');
                } else {
                    $featuredIconsButtons.addClass('hide');
                }
            }

            window.addEventListener("resize", UTIL.debounce( showHidePrevNext, 150 ));

        },
        debounce: function(func, time) {
            var time = time || 100; // 100 by default if no param
            var timer;
            return function(event){
                if(timer) clearTimeout(timer);
                timer = setTimeout(func, time, event);
            };
        },
    };

    $(document).ready(UTIL.loadEvents);

})(jQuery);

(function() {

    if (!String.prototype.trim) {
        (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
                return this.replace(rtrim, '');
            };
        })();
    }

    [].slice.call( document.querySelectorAll( 'input.input__field, textarea.input__field' ) ).forEach( function( inputEl ) {
        // in case the input is already filled..
        if( inputEl.value.trim() !== '' ) {
            classie.add( inputEl.parentNode, 'input--filled' );
        }

        // events:
        inputEl.addEventListener( 'focus', onInputFocus );
        inputEl.addEventListener( 'blur', onInputBlur );
    } );

    function onInputFocus( ev ) {
        classie.add( ev.target.parentNode, 'input--filled' );
    }

    function onInputBlur( ev ) {
        if( ev.target.value.trim() === '' ) {
            classie.remove( ev.target.parentNode, 'input--filled' );
        }
    }
})();